<ng-container *ngIf="areAllProductInformationPresent() else skeletonTemplate">
  <div class="columns is-justify-content-space-evenly mt-3 is-multiline">
    <div class="column is-4 package-col" *ngFor="let pricingPackage of fixedPricingPackages; let index = index;">
      <div class="h-100">
        <div #packageHead
             class="package-head card has-text-centered title is-4 has-round-border mb-5 is-flex is-justify-content-center is-align-items-center is-flex-direction-column"
             [ngStyle]="index%3 === 0 ? {'background-color':'#73B1D6'} : index%3 === 1 ? {'background-color':'#366E99'} : index%3===2 ? {'background-color':'#35566E'} : {}">
          <p>{{ pricingPackage.packageName }}</p>
          <p style="font-size: 1rem">{{ pricingPackage.packagePrice | currency: 'EUR' }}</p>
        </div>
        <div class="card package-body">
          <div class="columns" *ngFor="let explicitDocument of pricingPackage.explicitDocuments">
            <div class="column has-text-centered">
              <strong>{{ getProductNameByShortName(explicitDocument.documentName) }}</strong>

              <div *ngIf="explicitDocument.subClasses?.length">
                <p class="has-text-weight-semibold my-2">Teile:</p>
                <ul>
                  <li *ngFor="let subClass of explicitDocument.subClasses" class="list-style-none">
                    <span>
                      {{NameFinderUtils.getProductLongName(subClass, this.products, pbauakDocumentClass)}}
                    </span>
                    <span *ngIf="subClass === 'SONST' && explicitDocument.pbauakPartDescription">
                      - {{explicitDocument.pbauakPartDescription}}
                    </span>
                  </li>
                </ul>
              </div>

              <div *ngIf="explicitDocument.bookableServices?.length">
                <p class="has-text-weight-semibold my-2">Zusatzleistungen:</p>
                <ul>
                  <li *ngFor="let service of explicitDocument.bookableServices" class="list-style-none">
                    {{NameFinderUtils.getServiceLongName(bookableServicesByCategory,service)}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="columns" *ngIf="pricingPackage.informationText">
            <div class="column">
              <p class="has-text-weight-bold has-text-centered">{{pricingPackage.informationText}}</p>
            </div>
          </div>
          <div class="columns card is-clickable has-text-centered margin-auto package-button"
               [ngClass]="{'selected': isPackageSelected(pricingPackage)}"
               style="background-color: #f7f7f7;border-radius: 10px; align-items: center"
               (click)="isAllowedToOrder ? onPackageSelection(pricingPackage) : $event.stopPropagation()">
            <div class="column has-text-left">
              <p>In den Einkaufswagen</p>
            </div>
            <div class="column is-one-fifth has-text-right" style="padding-bottom: 15px">
              <ng-container *ngIf="isPackageSelected(pricingPackage) else showPlus">
                <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="23.186" height="20.777"
                     viewBox="0 0 23.186 20.777">
                  <path id="Icon_awesome-check" data-name="Icon awesome-check"
                        d="M7.875,24.946.34,15.891a1.6,1.6,0,0,1,0-1.97l1.639-1.97a1.027,1.027,0,0,1,1.639,0l5.076,6.1L19.567,4.985a1.027,1.027,0,0,1,1.639,0l1.639,1.97a1.6,1.6,0,0,1,0,1.97L9.514,24.946A1.027,1.027,0,0,1,7.875,24.946Z"
                        transform="translate(0 -4.577)" fill="#fff"/>
                </svg>
              </ng-container>
              <ng-template #showPlus>
                <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="21.043" height="21.043"
                     viewBox="0 0 21.043 21.043">
                  <path id="Icon_awesome-plus" data-name="Icon awesome-plus"
                        d="M19.54,10.517H12.776V3.753a1.5,1.5,0,0,0-1.5-1.5H9.77a1.5,1.5,0,0,0-1.5,1.5v6.764H1.5A1.5,1.5,0,0,0,0,12.02v1.5a1.5,1.5,0,0,0,1.5,1.5H8.267V21.79a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5V15.026H19.54a1.5,1.5,0,0,0,1.5-1.5v-1.5A1.5,1.5,0,0,0,19.54,10.517Z"
                        transform="translate(0 -2.25)" fill="#707070"/>
                </svg>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!rotationOrderView">
    <div class="columns mt-5rem">
      <ng-container *ngFor="let key of sortedKeys">
        <div class="column" *ngIf="key !== 'Eigentümerrecherche' && key != 'Leitungsauskünfte'">
          <div class="card has-text-centered title is-4 is-darkblue has-round-border mb-5"
               style="padding: 0.7rem; z-index: 1">{{ key }}
          </div>
          <div [ngClass]="{'new-grundakte-document': key ==='Grundakte', 'new-bauakten-document': key === 'Bauaktenarchivbesuche', 'new-digitiz-document': key === 'Digitalisierungsservice'}"
              class="card special-document-card is-justify-content-center is-align-items-center is-flex">
            <div *ngIf="key === 'Grundakte'" class="columns card is-clickable"
                 [ngClass]="{'selected': hasAnyDocumentFromCategory(productsByCategory.get(key))}"
                 (click)="isAllowedToOrder ? openBewilModal() : $event.stopPropagation()"
                 style="background-color: #f7f7f7;border-radius: 10px; align-items: center">
              <div class="column has-text-left">
                <p class="does-not-wrap">In den Einkaufswagen</p>
              </div>
              <div class="column is-one-fifth has-text-right" style="padding-bottom: 15px">
                <ng-container *ngIf="hasDocument(productsByCategory.get(key)[0].nameShort) else showPlus">
                  <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="23.186" height="20.777"
                       viewBox="0 0 23.186 20.777">
                    <path id="Icon_awesome-check" data-name="Icon awesome-check"
                          d="M7.875,24.946.34,15.891a1.6,1.6,0,0,1,0-1.97l1.639-1.97a1.027,1.027,0,0,1,1.639,0l5.076,6.1L19.567,4.985a1.027,1.027,0,0,1,1.639,0l1.639,1.97a1.6,1.6,0,0,1,0,1.97L9.514,24.946A1.027,1.027,0,0,1,7.875,24.946Z"
                          transform="translate(0 -4.577)" fill="#fff"/>
                  </svg>
                </ng-container>
                <ng-template #showPlus>
                  <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="21.043" height="21.043"
                       viewBox="0 0 21.043 21.043">
                    <path id="Icon_awesome-plus" data-name="Icon awesome-plus"
                          d="M19.54,10.517H12.776V3.753a1.5,1.5,0,0,0-1.5-1.5H9.77a1.5,1.5,0,0,0-1.5,1.5v6.764H1.5A1.5,1.5,0,0,0,0,12.02v1.5a1.5,1.5,0,0,0,1.5,1.5H8.267V21.79a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5V15.026H19.54a1.5,1.5,0,0,0,1.5-1.5v-1.5A1.5,1.5,0,0,0,19.54,10.517Z"
                          transform="translate(0 -2.25)" fill="#707070"/>
                  </svg>
                </ng-template>
              </div>
            </div>

            <div *ngIf="key === 'Digitalisierungsservice'" class="columns card is-clickable"
                 [ngClass]="{'selected': hasDocument(productsByCategory.get(key)[0].nameShort)}"
                 (click)="openDigitizationServiceModel()"
                 style="background-color: #f7f7f7;border-radius: 10px; align-items: center">
              <div class="column has-text-left">
                <p class="does-not-wrap">In den Einkaufswagen</p>
              </div>
              <div class="column is-one-fifth has-text-right" style="padding-bottom: 15px">
                <ng-container *ngIf="hasDocument(productsByCategory.get(key)[0].nameShort) else showPlus">
                  <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="23.186" height="20.777"
                       viewBox="0 0 23.186 20.777">
                    <path id="Icon_awesome-check" data-name="Icon awesome-check"
                          d="M7.875,24.946.34,15.891a1.6,1.6,0,0,1,0-1.97l1.639-1.97a1.027,1.027,0,0,1,1.639,0l5.076,6.1L19.567,4.985a1.027,1.027,0,0,1,1.639,0l1.639,1.97a1.6,1.6,0,0,1,0,1.97L9.514,24.946A1.027,1.027,0,0,1,7.875,24.946Z"
                          transform="translate(0 -4.577)" fill="#fff"/>
                  </svg>
                </ng-container>
                <ng-template #showPlus>
                  <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="21.043" height="21.043"
                       viewBox="0 0 21.043 21.043">
                    <path id="Icon_awesome-plus" data-name="Icon awesome-plus"
                          d="M19.54,10.517H12.776V3.753a1.5,1.5,0,0,0-1.5-1.5H9.77a1.5,1.5,0,0,0-1.5,1.5v6.764H1.5A1.5,1.5,0,0,0,0,12.02v1.5a1.5,1.5,0,0,0,1.5,1.5H8.267V21.79a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5V15.026H19.54a1.5,1.5,0,0,0,1.5-1.5v-1.5A1.5,1.5,0,0,0,19.54,10.517Z"
                          transform="translate(0 -2.25)" fill="#707070"/>
                  </svg>
                </ng-template>
              </div>
            </div>

            <div *ngIf="key === 'Bauaktenarchivbesuche'" (click)="openBauaktenModal()" class="columns card is-clickable"
                 [ngClass]="{'selected': findBauaktenDocument()}"
                 style="background-color: #f7f7f7;border-radius: 10px; align-items: center">
              <div class="column has-text-left">
                <p class="does-not-wrap">In den Einkaufswagen</p>
              </div>
              <div class="column is-one-fifth has-text-right" style="padding-bottom: 15px">
                <ng-container *ngIf="findBauaktenDocument() else showPlus">
                  <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="23.186" height="20.777"
                       viewBox="0 0 23.186 20.777">
                    <path id="Icon_awesome-check" data-name="Icon awesome-check"
                          d="M7.875,24.946.34,15.891a1.6,1.6,0,0,1,0-1.97l1.639-1.97a1.027,1.027,0,0,1,1.639,0l5.076,6.1L19.567,4.985a1.027,1.027,0,0,1,1.639,0l1.639,1.97a1.6,1.6,0,0,1,0,1.97L9.514,24.946A1.027,1.027,0,0,1,7.875,24.946Z"
                          transform="translate(0 -4.577)" fill="#fff"/>
                  </svg>
                </ng-container>
                <ng-template #showPlus>
                  <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="21.043" height="21.043"
                       viewBox="0 0 21.043 21.043">
                    <path id="Icon_awesome-plus" data-name="Icon awesome-plus"
                          d="M19.54,10.517H12.776V3.753a1.5,1.5,0,0,0-1.5-1.5H9.77a1.5,1.5,0,0,0-1.5,1.5v6.764H1.5A1.5,1.5,0,0,0,0,12.02v1.5a1.5,1.5,0,0,0,1.5,1.5H8.267V21.79a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5V15.026H19.54a1.5,1.5,0,0,0,1.5-1.5v-1.5A1.5,1.5,0,0,0,19.54,10.517Z"
                          transform="translate(0 -2.25)" fill="#707070"/>
                  </svg>
                </ng-template>
              </div>
            </div>

          </div>

        </div>

      </ng-container>
    </div>
  </div>

  <div id="products">
    <div *ngFor="let key of keys | slice:0:5; let i = index;" style="width: 100%">
      <div *ngIf="containsCategoryRotationableProduct(key) || !rotationOrderView"
           class="card has-text-centered title is-4 is-darkblue has-round-border mb-5"
           style="padding: 0.5rem;z-index: 1;font-weight: bold">{{ key }}
      </div>
      <div *ngIf="containsCategoryRotationableProduct(key) || !rotationOrderView" class="card products-card">
        <div class="columns" style="flex-wrap: wrap">
          <div class="column is-product w-30 is-one-third has-text-centered has-round-border card is-clickable"
               [ngClass]="{'selected': hasDocument(product.nameShort), 'not-active': !containsUserDocumentPricingSpecificDocument(product.nameShort) && isUserPricingTypeDocument()}"
               (click)="isAllowedToOrder ? addDocument(product.nameShort,null) : $event.stopPropagation()"
               style="align-items: center;display: inline-grid" *ngFor="let product of productsByCategory.get(key)">
            <div class="columns is-clickable" name="product">
              <ngx-skeleton-loader *ngIf="isLoadingEntryDates" appearance="line" animation="progress"
                                   [theme]="{'animation':'none','background':'#d7d7d7 no-repeat','position':'absolute','max-width':'30%','bottom':'-15%','height':'20%','right':'0','left':'0','margin-left':'auto','margin-right':'auto'}"></ngx-skeleton-loader>
              <div class="column has-text-left">
                {{ product.name_show }}
                <p class="entry-date has-text-grey has-text-centered"
                   *ngIf="savedId && documentEntryDate.size > 0 && documentEntryDate.get(savedId) && documentEntryDate.get(savedId)[product.nameShort] && isActualityExceeded(product)">
                  zuletzt bestellt am: {{ documentEntryDate.get(savedId)[product.nameShort] | date: 'dd.MM.yyyy' }}</p>
              </div>
              <div class="column is-one-fifth has-text-right">
                <ng-container *ngIf="hasDocument(product.nameShort) else showPlus">
                  <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="23.186" height="20.777"
                       viewBox="0 0 23.186 20.777">
                    <path id="Icon_awesome-check" data-name="Icon awesome-check"
                          d="M7.875,24.946.34,15.891a1.6,1.6,0,0,1,0-1.97l1.639-1.97a1.027,1.027,0,0,1,1.639,0l5.076,6.1L19.567,4.985a1.027,1.027,0,0,1,1.639,0l1.639,1.97a1.6,1.6,0,0,1,0,1.97L9.514,24.946A1.027,1.027,0,0,1,7.875,24.946Z"
                          transform="translate(0 -4.577)" fill="#fff"/>
                  </svg>
                </ng-container>
                <ng-template #showPlus>
                  <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="21.043" height="21.043"
                       viewBox="0 0 21.043 21.043">
                    <path id="Icon_awesome-plus" data-name="Icon awesome-plus"
                          d="M19.54,10.517H12.776V3.753a1.5,1.5,0,0,0-1.5-1.5H9.77a1.5,1.5,0,0,0-1.5,1.5v6.764H1.5A1.5,1.5,0,0,0,0,12.02v1.5a1.5,1.5,0,0,0,1.5,1.5H8.267V21.79a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5V15.026H19.54a1.5,1.5,0,0,0,1.5-1.5v-1.5A1.5,1.5,0,0,0,19.54,10.517Z"
                          transform="translate(0 -2.25)" fill="#707070"/>
                  </svg>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-12 has-text-right" style="padding-bottom: 5px;padding-right: 0">
          <a style="color: #366E99" (click)="addInfos(i+1)">für mehr Infos hier klicken</a>
        </div>
      </div>
    </div>

    <div>
      <div class="card has-text-centered title is-4 is-darkblue has-round-border mb-5"
           style="padding: 0.5rem;z-index: 1;font-weight: bold">{{ keys[5] }}
      </div>
      <div class="card products-card">
        <div class="mb-2rem" *ngFor="let category of planungProductsByCategory | keyvalue">
          <div class="card background-is-gray has-text-left title is-6 is-darkblue has-round-border mb-5"
               style="padding: 0.5rem 0.7rem;z-index: 1;font-weight: bold">
            {{ category.key }}
          </div>
          <div class="card products-card background-is-gray">
            <div class="columns max-w-100" style="flex-wrap: wrap">
              <div class="column is-full is-product is-planun-product w-100 has-round-border card is-clickable"
                   [ngClass]="{'selected': hasDocument(product.nameShort), 'not-active': !containsUserDocumentPricingSpecificDocument(product.nameShort) && isUserPricingTypeDocument()}"
                   (click)="isAllowedToOrder ? addDocument(product.nameShort,null) : $event.stopPropagation()"
                   style="align-items: center;display: inline-grid" *ngFor="let product of category.value">
                <div class="columns is-clickable">
                  <ngx-skeleton-loader *ngIf="isLoadingEntryDates" appearance="line" animation="progress"
                                       [theme]="{'animation':'none','background':'#d7d7d7 no-repeat','position':'absolute','max-width':'30%','bottom':'-15%','height':'20%','left':'15px','margin-left':'auto','margin-right':'auto'}"></ngx-skeleton-loader>
                  <div class="column">
                    <span *ngIf="product.nameShort !== 'planun'">{{ product.name_show }}</span>
                    <span class="product-info" *ngIf="product.nameShort === 'bebauu'"> inkl. Abfrage Aufstellungsbeschluss, Veränderungssperre und Beurteilung nach §§ 34 / 35 BauGB</span>
                    <span
                        *ngIf="product.nameShort === 'planun' && planungSubClassNames">  {{ planungSubClassNames.join(', ') }}</span>
                    <p class="entry-date has-text-grey has-text-left pl-4 "
                       *ngIf="savedId && documentEntryDate.size > 0 && documentEntryDate.get(savedId) && documentEntryDate.get(savedId)[product.nameShort] && isActualityExceeded(product)">
                      zuletzt bestellt
                      am: {{ documentEntryDate.get(savedId)[product.nameShort] | date: 'dd.MM.yyyy' }}</p>
                  </div>
                  <div class="column is-one-fifth is-flex is-justify-content-right is-align-items-center">
                    <ng-container *ngIf="hasDocument(product.nameShort) else showPlus">
                      <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="23.186"
                           height="20.777"
                           viewBox="0 0 23.186 20.777">
                        <path id="Icon_awesome-check" data-name="Icon awesome-check"
                              d="M7.875,24.946.34,15.891a1.6,1.6,0,0,1,0-1.97l1.639-1.97a1.027,1.027,0,0,1,1.639,0l5.076,6.1L19.567,4.985a1.027,1.027,0,0,1,1.639,0l1.639,1.97a1.6,1.6,0,0,1,0,1.97L9.514,24.946A1.027,1.027,0,0,1,7.875,24.946Z"
                              transform="translate(0 -4.577)" fill="#fff"/>
                      </svg>
                    </ng-container>
                    <ng-template #showPlus>
                      <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="21.043"
                           height="21.043"
                           viewBox="0 0 21.043 21.043">
                        <path id="Icon_awesome-plus" data-name="Icon awesome-plus"
                              d="M19.54,10.517H12.776V3.753a1.5,1.5,0,0,0-1.5-1.5H9.77a1.5,1.5,0,0,0-1.5,1.5v6.764H1.5A1.5,1.5,0,0,0,0,12.02v1.5a1.5,1.5,0,0,0,1.5,1.5H8.267V21.79a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5V15.026H19.54a1.5,1.5,0,0,0,1.5-1.5v-1.5A1.5,1.5,0,0,0,19.54,10.517Z"
                              transform="translate(0 -2.25)" fill="#707070"/>
                      </svg>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-12 has-text-right" style="padding-bottom: 5px;padding-right: 0">
          <a style="color: #366E99" (click)="addInfos(5+1)">für mehr Infos hier klicken</a>
        </div>
      </div>
    </div>
    <!--### Modals ###-->
    <app-modal [active]="showLeitungPricingOnRequestInformation"
               (modalClosed)="closeLeitungPricingOnRequestInformationModal()">
      <div class="title is-4 has-text-centered is-bold" style="color: #35566E !important;">Information</div>
      <div class="columns">
        <div class="column has-text-centered is-bold"><p>599€ zzgl. Behördenauslagen</p></div>
      </div>
      <div class="columns">
        <div class="column has-text-left title is-5 is-lightblue">
          <p>Details:</p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p class="has-text-weight-bold">Die Leitungsauskunft dient zur Abfrage beeinflussender Leitungen in Ihrem
            Bauprojekt.
            Im Rahmen Ihres Vorhaben werden alle relevanten Netzbetreiber (durch das Bauamt gelistet) angefragt. Hierzu
            gehören:</p>
        </div>
      </div>
      <div class="columns">
        <div class="column ml-5 has-text-weight-bold">
          <ul>
            <li>Stadtwerke/Grundversorger (Stromg, Gas, Wasser)</li>
            <li>Telekommunikationsbetreiber (Telekom, Vodafone und viele Weitere)</li>
            <li>Bauämter (Kanal, Beleuchtung)</li>
            <li>Nationale Strom- und Gas-Verteilnetzbetreiber</li>
            <li>viele Snder-Netzbetreiber wie die Deutsche Bahn, Betreiber von Signalanlagen, nationale oder lokale
              Wind- und Solarparkbetreiber
            </li>
          </ul>
        </div>
      </div>
      <div class="columns">
        <div class="column ml-5 mt-3">
          <p class="has-text-weight-bold">Pro Baustelle (mit maximal 500 x 500 m² Fläche oder 2 km Länge)</p>
        </div>
      </div>
      <div class="columns">
        <div class="column has-text-left title is-5 is-lightblue mt-3">
          <p>Lieferumfang:</p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p class="has-text-weight-bold">Anhand des übermittelten Reports erfahren Sie ob und welche Leitungen Ihr
            Bauprojekt beeinflussen können. Konkret bedeutet dies:</p>
        </div>
      </div>
      <div class="columns">
        <div class="column ml-5 has-text-weight-bold">
          <ul>
            <li>eine Liste aller beteiligten Netzbetriber/Organisationen</li>
            <li>Antworten dieser Netzbetreiber, die i.d.R. beinhalten</li>
            <li class="ml-6">Bestandsleitungspläne in PDF- oder digitalem Format (.dwg-/.dxf-/shape-Datei)</li>
            <li class="ml-6">Stellungnahmen, Schutzanweisungen, Merkblätter</li>
            <li>der dokumentierten Kommunikation (Anfragen + Antworten) mit jedem einzelnen Netzbetreiber</li>
          </ul>
        </div>
      </div>

      <div class="columns mt-3">
        <div class="column is-one-third">
          <a (click)="hasDocument('leitung') ? removeLeitungDocument() : null"
             class="button back-button is-size-6 has-round-border mb-1" style="border:none;"
             [ngClass]="{'disabled' : !hasDocument('leitung')}">
            <div class="columns" style="align-items: center;justify-content: center;">
              <img src="assets/images/orders-icons/trash-can.svg" alt="Trashcan">
            </div>
          </a>
        </div>
        <div class="column is-one-third"></div>
        <div class="column is-one-third">
          <a (click)="isAllowedToOrder ? addLeitungDocument() : $event.stopPropagation()" type="submit"
             class="button buy-button is-size-6 has-round-border"
             style="border:none;">
            <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
              <svg viewBox="202.186 194.402 38.812 34.8" width="38.812" height="34.8">
                <path
                    d="M 202.186 196.033 C 202.186 195.129 202.913 194.402 203.817 194.402 L 206.909 194.402 C 208.404 194.402 209.729 195.272 210.348 196.576 L 238.279 196.576 C 240.066 196.576 241.371 198.276 240.902 200.002 L 238.115 210.352 C 237.538 212.486 235.601 213.974 233.393 213.974 L 213.787 213.974 L 214.154 215.911 C 214.303 216.679 214.976 217.236 215.757 217.236 L 235.35 217.236 C 236.254 217.236 236.981 217.963 236.981 218.867 C 236.981 219.771 236.254 220.498 235.35 220.498 L 215.757 220.498 C 213.406 220.498 211.388 218.826 210.952 216.523 L 207.446 198.106 C 207.398 197.847 207.174 197.664 206.909 197.664 L 203.817 197.664 C 202.913 197.664 202.186 196.937 202.186 196.033 Z M 210.885 225.935 C 210.885 223.424 213.603 221.854 215.778 223.11 C 216.787 223.693 217.409 224.769 217.409 225.935 C 217.409 228.446 214.69 230.015 212.516 228.76 C 211.506 228.177 210.885 227.1 210.885 225.935 Z M 233.719 222.673 C 236.23 222.673 237.799 225.391 236.544 227.566 C 235.961 228.575 234.884 229.197 233.719 229.197 C 231.208 229.197 229.638 226.478 230.894 224.304 C 231.476 223.295 232.553 222.673 233.719 222.673 Z"
                    style="" fill="#fff"></path>
              </svg>
            </div>
          </a>
        </div>
      </div>
    </app-modal>

    <app-bauak-modal
      [active]="showBauaktenModal"
      [startOnGrundeStep]="startBauakModalOnGrundeStep"
      [user]="user"
      (modalClosed)="onBauakModalClosed()"
      (submitted)="onBauakSubmitted($event)"
      (removeRequested)="onBauakRemoveRequested()"
      [documents]="documents"
      [bauakProducts]="bauakProducts"
      [products]="products"
      [selectedProperty]="selectedProperty"
      [isConnectOrigin]="isConnectOrigin"
      [serviceCategories]="serviceCategories"
      [bookableServicesByCategory]="bookableServicesByCategory"
      [isAllowedToOrder]="isAllowedToOrder">
    </app-bauak-modal>

    <app-grundakte-modal
      [active]="showBewilModal"
      [user]="user"
      [documents]="documents"
      [products]="products"
      [grundakteProducts]="grundakten"
      [selectedProperty]="selectedProperty"
      [isConnectOrigin]="isConnectOrigin"
      [isAllowedToOrder]="isAllowedToOrder"
      (modalClosed)="cancelBewilDocuments()"
      (submitted)="onGrundakteSubmitted($event)"
      (removeRequested)="onGrundakteRemoveRequested()">
    </app-grundakte-modal>

    <app-modal #addDigitizationServiceModal [active]="showDigitizationServiceInformation"
               (modalClosed)="closeDigitizationServiceInformationModal()">
      <form *ngIf="digitizationServiceForm" [formGroup]="digitizationServiceForm">
        <div class="title is-3 has-text-centered is-bold color-darkblue">
          Scan & Archiv
        </div>
        <div class="subtitle is-size-5 has-text-grey has-text-centered">
          Ihr Digitalisierungsservice für Ihre physischen Unterlagen
        </div>

        <div class="info-border mb-3">
          <div class="columns">
            <div class="column has-text-centered">
              <p class="is-size-4 has-text-centered is-bold color-darkblue">
                Hinweis:
              </p>
            </div>
          </div>
          <div class="columns">
            <div class="column has-text-centered">
              <p class="is-5 has-text-centered is-bold">
                Sie verursachen noch keine Kosten. Nach der Bestellung erhalten Sie anhand Ihrer Angaben zum
                Umfang
                der Akten und der gewünschten Services ein Angebot, welches Sie annehmen oder ablehnen
                können.
              </p>
            </div>
          </div>
        </div>

        <div *ngIf="showInvalidInputs" class="title is-5 has-text-centered required">
          Bitte füllen Sie zunächst alle Pflichtfelder aus.
        </div>


        <div class="info-border p-5">
          <div class="title is-5 has-text-left is-darkblue mb-1">Scanservice:</div>
          <div class="columns">
            <div class="column">
              <p class="is-bold">Leistungsumfang:</p>
            </div>
          </div>
          <div class="columns">
            <div class="column ml-5 has-text-weight-bold">
              <ul>
                <li>Entfernen von Heftklammern und Tackernadeln, Entnahme der Dokumente aus Hüllen, Heftern,
                  Ordnern etc.
                </li>
                <li>Scannen mit Auflösung von 300 DPI (Farbe)</li>
                <li>Sie erhalten PDF/A-Dateien mittels Texterkennung (OCR)</li>
                <li>Onlinebereitstellung auf Ihrer Connect+ Plattform</li>
              </ul>
            </div>
          </div>
          <div class="columns ml-3">
            <div class="column is-half">
              <p class="has-text-weight-bold is-size-7">
                Dokumente < A2 Format<br>(Kein Aufpreis für geöste/gebundene Dokumente etc.)
              </p>
            </div>
            <div class="column is-half">
              <p class="has-text-weight-bold is-size-7 is-lightblue">
                ab 0,12 €/Seite
              </p>
            </div>
          </div>
          <div class="columns ml-3">
            <div class="column is-half">
              <p class="has-text-weight-bold is-size-7">
                Dokumente (Pläne) ab A2 Format
              </p>
            </div>
            <div class="column is-half">
              <p class="has-text-weight-bold is-size-7 is-lightblue">
                ab 10,00 €/Seite
              </p>
            </div>
          </div>
        </div>

        <div class="title is-5 has-text-left is-darkblue mb-1 mt-3">
          Anzahl der Unterlagen
        </div>

        <div class="columns">
          <div class="column">
            <input formControlName="numberOfFolders" type="number" class="border-input additional-info"
                   placeholder="Anzahl der zu digitalisierenden Ordner">
          </div>
        </div>

        <div class="is-size-7 has-text-grey mb-3">
          Hinweis: Ein Aktenordner entspricht ca. 400 - 600 losen Seiten.
        </div>

        <ng-container *ngIf="serviceCategories && digitizationServiceForm">
          <div class="title is-5 has-text-left is-darkblue mb-5 mt-5">
            {{ getCategoryLongName(serviceCategories, "Versand") }}
          </div>
          <app-service-renderer [services]="bookableServicesByCategory.get('Versand')"

                                categoryId="vservice"
                                groupName="shippingServices"
                                [formGroup]="digitizationServiceForm"
                                [digitizationServiceApproximatePricing]="digitizationServiceApproximatePricing">
          </app-service-renderer>

          <div class="title is-5 has-text-left is-darkblue mb-5 mt-5">
            {{ getCategoryLongName(serviceCategories, "Rueckversand") }}
          </div>
          <app-service-renderer [services]="bookableServicesByCategory.get('Rueckversand')"
                                categoryId="rservice"
                                groupName="storageServices"
                                [formGroup]="digitizationServiceForm"
                                [digitizationServiceApproximatePricing]="digitizationServiceApproximatePricing">
          </app-service-renderer>

          <div class="title is-5 has-text-left is-darkblue mb-5 mt-5">
            {{ getCategoryLongName(serviceCategories, "ABServices") }}
          </div>
          <app-service-renderer [services]="bookableServicesByCategory.get('ABServices')"
                                [useCheckboxes]="true"
                                categoryId="abservice"
                                groupName="additionalServices"
                                [formGroup]="digitizationServiceForm"
                                [digitizationServiceApproximatePricing]="digitizationServiceApproximatePricing">
          </app-service-renderer>
        </ng-container>
        <div class="columns mt-3">
          <div class="column is-one-third">
            <a (click)="hasDocument('digitiz') ? removeDigitizationDocument() : null"
               class="button back-button is-size-6 has-round-border mb-1"
               [ngClass]="{'disabled' : !hasDocument('digitiz')}"
               style="border:none;"> <!--display: block !important;-->
              <div class="columns" style="align-items: center;justify-content: center">
                <img src="assets/images/orders-icons/trash-can.svg" alt="Trashcan">
              </div>
            </a>
          </div>
          <div class="column is-one-third"></div>
          <div class="column is-one-third">
            <a (click)="isAllowedToOrder ? addDigitizationDocument() : $event.stopPropagation()" type="submit"
               class="button buy-button is-size-6 has-round-border mb-1"
               style="border:none;">
              <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                <svg viewBox="202.186 194.402 38.812 34.8" width="38.812" height="34.8">
                  <path
                      d="M 202.186 196.033 C 202.186 195.129 202.913 194.402 203.817 194.402 L 206.909 194.402 C 208.404 194.402 209.729 195.272 210.348 196.576 L 238.279 196.576 C 240.066 196.576 241.371 198.276 240.902 200.002 L 238.115 210.352 C 237.538 212.486 235.601 213.974 233.393 213.974 L 213.787 213.974 L 214.154 215.911 C 214.303 216.679 214.976 217.236 215.757 217.236 L 235.35 217.236 C 236.254 217.236 236.981 217.963 236.981 218.867 C 236.981 219.771 236.254 220.498 235.35 220.498 L 215.757 220.498 C 213.406 220.498 211.388 218.826 210.952 216.523 L 207.446 198.106 C 207.398 197.847 207.174 197.664 206.909 197.664 L 203.817 197.664 C 202.913 197.664 202.186 196.937 202.186 196.033 Z M 210.885 225.935 C 210.885 223.424 213.603 221.854 215.778 223.11 C 216.787 223.693 217.409 224.769 217.409 225.935 C 217.409 228.446 214.69 230.015 212.516 228.76 C 211.506 228.177 210.885 227.1 210.885 225.935 Z M 233.719 222.673 C 236.23 222.673 237.799 225.391 236.544 227.566 C 235.961 228.575 234.884 229.197 233.719 229.197 C 231.208 229.197 229.638 226.478 230.894 224.304 C 231.476 223.295 232.553 222.673 233.719 222.673 Z"
                      style="" fill="#fff"></path>
                </svg>
              </div>
            </a>
          </div>
        </div>
      </form>
    </app-modal>

    <app-contact-overlay #contactOverlayComponent *ngIf="requestDocumentPriceName" [displayed]="showContactSupportModal"
                         (modalClosed)="closeRequestDocumentPricingContactOverlay()" [user]="user"
                         [requestDocumentPriceName]="requestDocumentPriceName"></app-contact-overlay>

  </div>
</ng-container>

<ng-template #skeletonTemplate>
  <div class="columns">
    <div class="column" *ngFor="let _ of [].constructor(3)">
      <div class="card has-text-centered title is-4 is-darkblue has-round-border mb-5 z-index-1"
           style="padding: 0.7rem">
        <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'50%'}"
                             animation="progress" appearance="line" count="1">
        </ngx-skeleton-loader>
      </div>
      <div class="card special-document-card">
        <div class="background-is-gray is-align-items-center border-radius-10">
          <div class="column has-text-left">
            <p class="does-not-wrap">
              <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'100%'}"
                                   animation="progress" appearance="line" count="1">
              </ngx-skeleton-loader>
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div *ngFor="let _ of [].constructor(5)" class="w-100">
    <div class="card has-text-centered title is-4 is-darkblue has-round-border mb-5 p-1 z-index-1">
      <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'30%'}"
                           animation="progress" appearance="line" count="1">
      </ngx-skeleton-loader>
    </div>
    <div class="card products-card">
      <div class="columns" style="flex-wrap: wrap">
        <div
            class="column is-product w-30 is-one-third has-text-centered has-round-border card is-align-items-center d-inline-grid"
            *ngFor="let _ of [].constructor(5)">
          <div class="columns" name="product">
            <div class="column has-text-left">
              <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'30%','height':'15px'}"
                                   animation="progress" appearance="line" count="1">
              </ngx-skeleton-loader>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12 has-text-right pr-0 p-bottom-5px">
        <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'30%'}"
                             animation="progress" appearance="line" count="1">
        </ngx-skeleton-loader>
      </div>
    </div>
  </div>
</ng-template>
